import { useTranslations } from '@vocab/react';
import { Box, Text, Stack, Strong } from 'braid-design-system';

import translations from './.vocab';
import { NoSearchResultSvg } from './images/no-search-result';

export const NoSearchResults = () => {
  const { t } = useTranslations(translations);

  return (
    <Box paddingY="xxlarge">
      <Box
        paddingY="xxlarge"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Stack space="small" align="center">
          <NoSearchResultSvg />
          <Text align="center">
            <Strong>{t('NO_MATCHING_PROFILES')}</Strong>
          </Text>
          <Text align="center" tone="secondary">
            {t('COULD_NOT_FIND_ANY_PROFILES_THAT_MATCHED_YOUR_SEARCH')}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
